/** @format */

import { apiConfig } from "core-lib/config/config";
import { getMethod, postMethod } from "core-lib/utils/apiV2";

const SEO_BASE_URL = apiConfig("seoService");

// export const getAutoCompleteSuggestions = async (searchText) => {
//   const url = `${SEO_BASE_URL}/api/v1/auto-complete?text=${searchText}`;
//   const { response }: any = await getMethod({ endPoint: url });
//   if (response?.data?.length) {
//     return response?.data || [];
//   }
//   return [];
// };

export const getAutoCompleteSuggestions = async (searchText, serviceName = "PWA") => {
  const url = `${apiConfig("infra")}/api/v4/infra/searchPlace/list/`;
  const { response }: any = await postMethod({
    endPoint: url,
    body: {
      searched_place: searchText,
      is_google_search: true,
      source: serviceName,
    },
  });
  if (response?.data?.predictions?.length) {
    return response?.data?.predictions || [];
  }

  return [];
};